import React, { FC } from 'react';
import styled from 'styled-components';
import CustomAttributesContainer from './CustomAttributesContainer';

export const CustomAttributesPage: FC = () => {
  return (
    <CustomAttributesPageLayout data-aid="custom-attributes-page-layout">
      <CustomAttributesContainer />
    </CustomAttributesPageLayout>
  );
};

export default CustomAttributesPage;

const CustomAttributesPageLayout = styled.div`
  background-color: transparent;
  bottom: 0;
  box-sizing: border-box;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 10;
  opacity: 1;
  background-color: ${p => p.theme.colors.gray100};
  align-items: center;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  margin: 0 auto;
  margin-top: ${p => p.topPadding}px;
  overflow: auto;
  width: 100%;
`;
